import { Component } from '@angular/core'

@Component({
  standalone: false,
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent {}
